import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cthulhu",
  "description": "",
  "published": "2006-08-14T00:00:00.000Z",
  "redirect_from": ["/blog/cthulhu/swizec/388"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here we go, the news I've been dreading to tell for some days now, but it has to be told and I have to bear the stupidity of it all, so no use postponing, oh no, no use for that at all, nope, no use. Stopping procrastination mode... now.`}</p>
    <p>{`The bad news, yes it is a piece of rather bad news, rancid ones almost. The news in question is that Cthulhu seems to have grown rather vain and has decided to mess with the artist if he doesn't get enough of an appearance in a certain comic. The comic in question is the page that has been going on rather long enough and has been delayed postponed, dead and broken and finally... canceled. Yes that's right, I've decided to simply not finish the page. Some force has ruined my work not once, but twice and when it happened last Thursday I finally decided... you know what... screw this.`}</p>
    <p>{`Without the page I will take care to produce daily sketches... daily and will be starting work on September's page rather soonly and hopefully that one will fare better than the canceled one.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      